import { type ReactNode } from 'react'
import { getInitialism, useAccountStatuses } from '@front/model'
import { Group, Text, useMantineTheme } from '@mantine/core'
import { isEmpty, isNotDefined, type AccountStatusId } from '@terros/common'
import { LoadingEntityInfo } from '../entityInfo/EntityInfo'
import { IconDisplay } from '../terros'

type Props = {
  statusId: AccountStatusId
  size?: 'sm' | 'md'
}

export const AccountStatusInfo = ({ statusId, size = 'md' }: Props): ReactNode => {
  const theme = useMantineTheme()
  const { data, isLoading } = useAccountStatuses({ archived: 'all' })
  if (isLoading) {
    return <LoadingEntityInfo />
  }
  const status = data?.statuses.find((s) => s.statusId === statusId)
  if (isNotDefined(status)) return null

  const iconText = getInitialism(isEmpty(status.short) ? status.name : status.short)
  const icon = status.icon ?? iconText
  const color = status.color ?? theme.colors.gray[5]

  return (
    <Group>
      <IconDisplay color={color} icon={icon} size={size} />
      <Text size={size}>{status.name}</Text>
    </Group>
  )
}
